const getDecimalPointSymbol = (price) => {
  const decimal = price.charAt(price.length - 3);
  return decimal === '.' || decimal === ',' ? decimal : null;
};

const getThousandsSeparator = (price) => {
  const wholeNumber = price.split(getDecimalPointSymbol(price))[0];
  return (wholeNumber.length > 4 && wholeNumber.charAt(wholeNumber.length - 4)) || '';
};

const getFloatNumber = (price, thousandSeparator) => {
  if (thousandSeparator) {
    const reg = new RegExp(`\\${thousandSeparator}`, 'g');
    const priceWithoutSeparator = price.replace(reg, '');

    return parseFloat(getDecimalPointSymbol(priceWithoutSeparator) === ',' ? priceWithoutSeparator.replace(/,/g, '.') : priceWithoutSeparator);
  }

  return parseFloat(price);
};

const addThousandsSeparator = (price, thousandSeparator) => price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
const addDecimalPoint = (price, decimalPoint) => price.toString().replace('.', decimalPoint);
const formatNumber = (price, decimalPoint, thousandSeparator) => {
  const decimalPrice = addDecimalPoint(price, decimalPoint);
  return addThousandsSeparator(decimalPrice, thousandSeparator);
};

const roundFloatToDecimalPoints = (number, decimalPoints) => {
  const plusExpo = 'e+' + decimalPoints;
  const minusExpo = 'e-' + decimalPoints;
  const roundedByMultiplicationUp = Math.round(number + plusExpo);
  const truncatedByDivision = parseFloat(roundedByMultiplicationUp + minusExpo);
  return truncatedByDivision;
}

export const getAmountAfterDiscount = (strAmount, discountRate, decimalPoints = 2) => {
  const decimalPointSymbol = getDecimalPointSymbol(strAmount);
  const thousandSeparator = getThousandsSeparator(strAmount);
  const amount = getFloatNumber(strAmount, thousandSeparator);
  const amountAfterDiscount = decimalPointSymbol ?
    roundFloatToDecimalPoints(amount - (amount * discountRate), decimalPoints).toFixed(2) :
    roundFloatToDecimalPoints(amount - (amount * discountRate), decimalPoints).toFixed(0);

  return formatNumber(amountAfterDiscount, decimalPointSymbol, thousandSeparator);
};

export const voucherExpired = voucherExpiryDate => new Date(voucherExpiryDate) < new Date();

export const getCurrencyAmount = (strPriceView) => {
  const strPriceViewTrimmed = strPriceView.trim();
  const amountRegex = /[0-9]+(\,[0-9]+)*(\.[0-9]+)?/;
  const amountMatches = strPriceViewTrimmed.match(amountRegex);
  const amount = amountMatches && amountMatches.length > 0 ? amountMatches[0] : '';

  const currencyRegex = /[^\d\,\.\s]+/;
  const currencyMatches = strPriceViewTrimmed.match(currencyRegex);
  const currency = currencyMatches && currencyMatches.length > 0 ? currencyMatches[0] : '';

  const currencyAtRightRegex = /^\d/;
  const currencyOnRight = currencyAtRightRegex.test(strPriceViewTrimmed);

  return [currency, amount, currencyOnRight];
};

export const getDiscountedAmount = (strAmount, discountAmount, decimalPoints = 2) => {
  const decimalPointSymbol = getDecimalPointSymbol(strAmount);
  const thousandSeparator = getThousandsSeparator(strAmount);
  const amount = getFloatNumber(strAmount, thousandSeparator);
  const amountAfterDiscount = roundFloatToDecimalPoints(amount - discountAmount, decimalPoints)
    .toFixed(decimalPointSymbol ? 2 : 0);

  return formatNumber(amountAfterDiscount, decimalPointSymbol, thousandSeparator);
}



// WEBPACK FOOTER //
// ./src/Common/Helpers/SlashPrice/SlashPriceHelper.js